import { render, staticRenderFns } from "./ConsultaPreFaturaReceitaFilterBar.vue?vue&type=template&id=2a0885e6"
import script from "./ConsultaPreFaturaReceitaFilterBar.vue?vue&type=script&lang=js"
export * from "./ConsultaPreFaturaReceitaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports